import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
import { Box } from '../Box/Box';

type GridProps = Omit<ComponentPropsWithoutRef<typeof Box>, 'role'>;

export const GridPopover = forwardRef<HTMLDivElement, GridProps>(
  function GridPopover({ children, ...props }, ref) {
    return (
      <Box
        ref={ref}
        bg="white"
        borderRadius="popover"
        border={1}
        borderColor="popoverBorderColor"
        boxShadow="popover"
        overflow="auto"
        zIndex={1011}
        className={props.className}
        py="sp-4"
        maxHeight="398px"
        {...props}
        role="grid"
      >
        <Box key={children}>{children}</Box>
      </Box>
    );
  }
);
